"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
Object.defineProperty(exports, "__esModule", { value: true });
__exportStar(require("./common"), exports);
__exportStar(require("./Class"), exports);
__exportStar(require("./School"), exports);
__exportStar(require("./Parent"), exports);
__exportStar(require("./Student"), exports);
__exportStar(require("./Teacher"), exports);
__exportStar(require("./InvalidStudent"), exports);
__exportStar(require("./InvalidTeacher"), exports);
__exportStar(require("./SchoolGroup"), exports);
__exportStar(require("./SchoolGroupLink"), exports);
//# sourceMappingURL=index.js.map